export const DEFAULT_WIDTH = 1050;
